"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialBannerValues = exports.columns = void 0;
exports.columns = [
    { name: "Title", uid: "title", sortable: true },
    { name: "Image", uid: "image", sortable: false },
    { name: "Sort Order", uid: "sort_order", sortable: true },
    { name: "Active", uid: "active", sortable: true },
    { name: "Start Date", uid: "start_date", sortable: true },
    { name: "End Date", uid: "end_date", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
exports.initialBannerValues = {
    title: "",
    image: "",
    video_link: "",
    sort_order: 0,
    link_type: "",
    link_target: "",
    start_date: "",
    end_date: "",
    active: true,
};
